import React from "react"

export const ZERO_WIDTH_SPACE = <>&#8288;</>
export const SMALL_HYPHEN_MINUS = <>&#65123;</>
export const DOUBLE_SOFT_HYPHEN = <>&#6150;&#6150;</>
export const SOFT_HYPHEN = <>&#6150;</>
export const MIDLINE_ELLIPSIS = <>&#8943;</>
export const NON_BREAKING_HYPHEN = <>&#8209;</>

// export const NO_INFORMATION_SYMBOL = DOUBLE_SOFT_HYPHEN
export const NO_INFORMATION_SYMBOL = SOFT_HYPHEN

// export const CHECK_MARK = String.fromCodePoint(0x2713)
export const CHECK_MARK = <>&#x2713;</>
// export const CHECK_MARK = <>&#x2714;</>
// export const CHECK_MARK = <>&#x2611;</>

export const ARROW_DOWN = <>&#x25BC;</>
export const ARROW_RIGHT = <>&#x25B6;</>

export const EYES_EMOJI = <>&#128064;</>
